import { createTheme, ThemeProvider } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#4a6587",
    },
    custom: {
      main: "#ff0000",
    },
  },
});
